import { isMacLike } from "@/utils/platform";

export const SHOW_NUDGE_DOWNLOAD_APP = "SHOW_NUDGE_DOWNLOAD_APP";

/**
 * Whether the nudge should be shown based on platform, desktop context, and feature flag.
 */
export function showNudgeDownloadApp(isDesktop: boolean, flagEnabled: boolean, flagLoading: boolean): boolean {
    if (flagLoading || !flagEnabled) return false;
    if (isDesktop) return false;
    if (!isMacLike()) return false;
    return true;
}
